import styled from 'styled-components';
import { colors } from '@theme/globals/colors';
import { TypographySettings } from '@theme/globals/typography';
import { Sizes } from '@theme/globals/sizing';
import { isLegalColor } from '@theme/utils/colors';

interface RuleLineProps {
  background: string;
  direction: 'row' | 'column';
  thickness: string | number;
  length: string | number;
}
interface RuleLabelProps {
  color: string;
}

export const RuleLine = styled.div<RuleLineProps>`
  display: block;
  background-color: ${(props): string => {
    if (colors[props.background]) {
      return colors[props.background] as string;
    }
    if (isLegalColor(props.background)) {
      return props.background;
    }
    return 'black';
  }};
  height: ${(props) =>
    props.direction === 'row' ? props.thickness : props.length};
  width: ${(props) =>
    props.direction === 'row' ? props.length : props.thickness};
`;

export const RuleLabel = styled.span<RuleLabelProps>`
  color: ${(props): string => {
    if (colors[props.color]) {
      return colors[props.color] as string;
    }
    if (isLegalColor(props.color)) {
      return props.color;
    }
    return 'black';
  }};
  display: 'block',
  font-size: ${TypographySettings.subhead.size},
  font-weight: ${TypographySettings.subhead.weight},
  padding: 0 ${Sizes[16]};
`;
